import React from 'react';
import AwsServiceIcon from './AwsServiceIcon';
import { PLACEHOLDER } from './serviceStats';

// Full-width status card. Presentational only: it renders the service name, an
// optional cost badge, the service's full numeric metric set in a dense stat
// mini-grid, and that service's chart(s) inline. The grid cells come from the
// shared serviceStats descriptors and the chart body from serviceCharts, so a
// service's numeric field list and its chart JSX are each defined exactly once.
//
// ServiceTile.cloneElement injects the status treatment onto this element's
// root (className with service-tile-interactive, data-status) and PREPENDS the
// status pill as the first child. Everything in `rest` must therefore spread
// onto the root <div>, and {children} (the injected pill) must render before
// the card body.
//
// Null stat values render as the placeholder ('—'); the resolver in
// serviceStats returns null (never a fabricated 0) where the source is null.
const SummaryTile = ({
  displayName,
  serviceKey,
  cost,
  stats,
  charts,
  children,
  ...rest
}) => {
  const monthlyCost = Number(cost) || 0;
  const cells = Array.isArray(stats) ? stats : [];
  return (
    <div {...rest}>
      {children}
      <div className="summary-tile-header">
        <span className="summary-tile-name">
          <AwsServiceIcon service={serviceKey} />
          {displayName}
        </span>
        {monthlyCost > 0 && (
          <span className="cost-badge summary-tile-cost">${monthlyCost.toLocaleString()}/mo</span>
        )}
      </div>
      <div className="tile-stat-grid">
        {cells.map((cell, idx) => (
          <div key={idx} className="tile-stat">
            <span className="tile-stat-label">{cell.label}</span>
            <span className={`tile-stat-value ${cell.tone || ''}`.trim()}>
              {cell.value != null ? cell.value : PLACEHOLDER}
              {cell.hint && <span className="tile-stat-hint"> {cell.hint}</span>}
            </span>
          </div>
        ))}
      </div>
      {charts && <div className="summary-tile-charts">{charts}</div>}
    </div>
  );
};

export default SummaryTile;
